module.exports = __webpack_public_path__ + "static/media/04.33828a0f.jpg";